module.exports = {
  buildVersion: "0.1.26",
  buildDate: 1751024964728,
}